import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'disallowEmptyIf'
})
export class DisallowEmptyIfPipe implements PipeTransform {
    transform(validationInfo: any, hasBids: boolean): any {
        return {
            ...validationInfo,
            validations: {
                ...validationInfo.validations,
                customValidation: {
                    errorMessage:
                        'Sorry, your contact number cannot be removed once your auction has bids.',
                    enable: hasBids,
                    validate: (val: any) => {
                        return (
                            val !== null &&
                            val !== undefined &&
                            String(val).trim().length > 0
                        );
                    }
                }
            }
        };
    }
}
